<template>
  <div class="page-header-index-wide">
    <a-row :gutter="[8, 0]" class="playground" style="margin: -4px 0;">
      <a-col :sm="24" :md="12" :xl="8" class="playground" v-for="item in taskList">
        <chart-card :loading="loading" :needNum="false" title=" " class="task">
          <a-tooltip :title="$t(item.tips)" slot="action">
            <a-icon type="info-circle-o" />
          </a-tooltip>
          <div slot="content">
            <a-row :gutter="[8, 0]">
              <a-col :span="6" style="display: flex;justify-content: center;">
                <div class="task-icon">
                  <a-icon type="audit" />
                </div>
              </a-col>
              <a-col :span="18">
                <div class="task-content">
                  <div class="task-label">{{ $t(item.label) }}</div>
                  <div class="task-num">{{item.num}}</div>
                </div>
              </a-col>
            </a-row>
          </div>
        </chart-card>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 0]" class="playground">
      <a-col :sm="24" :md="24" :xl="12">
        <a-col :span="24">
          <!-- <a-card title="业务类别占比" :bordered="false" style="width: 100%">
            <a slot="extra" href="#">more</a>
            <div id="option1" style="height: 300px;width: 100%;"></div>
          </a-card> -->
        <chart-card :loading="loading" :bordered="false" :title="$t('业务类别占比')" :needNum="false" style="width: 100%;">
          <!-- <div slot="action">
            <a-button type="link">更多</a-button>
          </div> -->
          <div slot="content" style="height: 300px;width: 100%;display: flex;justify-content: center;">
            <div id="option1" style="height: 100%;width:100%;"></div>
          </div>
        </chart-card>
        </a-col>
      </a-col>
      <a-col :sm="24" :md="24" :xl="12">
        <a-col :span="24">
        <chart-card :loading="loading" :bordered="false" :title="$t('我的待办')" :needNum="false">
          <div slot="action">
            <a-button type="link" @click="onMore">{{ $t('更多') }}</a-button>
          </div>
          <div slot="content" class="table-fixed" style="height: 300px;">
            <a-table
              ref="table"
              size="middle"
              :scroll="{x:true,y:true}"
              bordered
              rowKey="procInsId"
              :pagination="false"
              :columns="columns"
              :dataSource="dataSource"
              :loading="loading"
              :components="drag(columns)"
              style="height: 100%;"
              @change="handleTableChange">
              
              <template slot="procDefVersion" slot-scope="text, record, index">
                  <el-tag size="medium" >V{{ record.procDefVersion }}</el-tag>
              </template>
              <template slot="startUserName" slot-scope="text, record, index">
                 <label>{{record.startUserName}} <el-tag type="info" size="mini">{{record.startDeptName}}</el-tag></label>
              </template>
            </a-table>
          </div>
        </chart-card>
        </a-col>
      </a-col>
    </a-row>
    <a-row :gutter="[8, 0]" class="playground">
      <a-col :sm="24" :md="24" :xl="24">
        <a-col :span="24">
        <chart-card :loading="loading" :bordered="false" :title="$t('业务数量')" :needNum="false" style="width: 100%;">
          <div slot="action">
            <a-radio-group default-value="1" @change="onChange">
              <a-radio-button value="1">
                {{ $t('近一周') }}
              </a-radio-button>
              <a-radio-button value="2">
                {{ $t('近一月') }}
              </a-radio-button>
              <a-radio-button value="3">
                {{ $t('近一年') }}
              </a-radio-button>
            </a-radio-group>
            <!-- <a-range-picker style="margin-left: 20px;" valueFormat="YYYY-MM-DD" @change="onRangeTime">
              <a-icon slot="suffixIcon" type="calendar" />
            </a-range-picker> -->
          </div>
          <div slot="content" style="height: 300px;width: 100%;display: flex;justify-content: center;">
            <div id="option2" style="height: 100%;width:100%;"></div>
          </div>
        </chart-card>
        </a-col>
      </a-col>
    </a-row>
  </div>
</template>

<script>
  import ChartCard from '@/components/ChartCard'
  import echarts from 'echarts'
  import '@/assets/less/TableExpand.less'
  // import { mixinDevice } from '@/utils/mixin'
  // import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import TableDragResize  from '@/mixins/TableDragResize'
  import { postAction,getAction } from '@/api/manage'
  import {
    filterDictTextByMany,
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  export default{
    components:{
      ChartCard
    },
    mixins:[TableDragResize],
    data() {
      return{
        loading: false,
        taskList: [{
          label: '待办事项',
          num: 0,
          tips: '这是待办事项'
        }, {
          label: '已办事项',
          num: 0,
          tips: '这是已办事项'
        }, {
          label: '事项完成率',
          num: '0%',
          tips: '这是事项完成率'
        }],
        url: {
          list: "/jeecg-engineering/engineering/installationDetail/list",
          queryHomeIndexTodo: "/jeecg-engineering/engineering/installationDetail/queryHomeIndexTodo",
          queryHomeIndexDone: "/jeecg-engineering/engineering/installationDetail/queryHomeIndexDone",
          queryHomeIndexTypeNum: "/jeecg-engineering/engineering/installationDetail/queryHomeIndexTypeNum",
          queryHomeIndexStatsNum: "/jeecg-engineering/engineering/installationDetail/queryHomeIndexStatsNum",
        },
        dataSource: [],
        queryParam: {},
      }
    },
    computed: {
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title:this.$t('报装编号'),
            align:"center",
            dataIndex: 'installationNum',
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('名称'),
            align:"center",
            dataIndex: 'clientName',
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('报装类型'),
            align:"center",
            dataIndex: 'installationType',
            customRender: (text) => {
             return filterDictTextByCache('installationType', text)
             },
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('报装状态'),
            align:"center",
            dataIndex: 'installationState',
            customRender: (text) => {
             return filterDictTextByCache('installationState', text)
             },
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('当前任务'),
            align:"center",
            dataIndex: 'currentNode',
            customRender: (text) => {
             return filterDictTextByCache('currentNode', text)
             },
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('当前节点处理人'),
            align:"center",
            dataIndex: 'approverName',
            customRender: (text) => {
              if(text){
                return text
              }else{
                return '/'
              }
            },
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('申请人'),
            align:"center",
            dataIndex: 'createBy',
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('申请时间'),
            align:"center",
            dataIndex: 'createTime',
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('更新时间'),
            align:"center",
            dataIndex: 'updateTime',
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('历时'),
            align:"center",
            dataIndex: 'diachronic',
            width: 150,
            ellipsis: true,
          },
          {
            title:this.$t('来源'),
            align:"center",
            dataIndex: 'sourceType',
            customRender: (text) => {
              if(text == 1){
                return this.$t('小程序')
              }else if(text == 2){
                return this.$t('公众号')
              }else{
                return 'PC'
              }
            },
            width: 150,
            ellipsis: true,
          },
        ]
      },
    },
    mounted(){
      this.getHomeIndexTodo();
      this.getHomeIndexTypeNum(1);
      this.getHomeIndexStatsNum(1);
      this.setMytodoList();
    },
    methods:{
      // 获取待办数量
      getHomeIndexTodo(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexTodo,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.taskList[0].num = data.toDo;
            this.getHomeIndexDone().then(val=>{
              this.taskList[2].num = ((val.done / (val.done+data.toDo))*100).toFixed(2) +'%';
            })
          }
        })
      },
      // 获取已办数量
      getHomeIndexDone(queryType,beginTime,endTime){
        return new Promise((resolve,reject)=>{
          var params = {
            queryType,
            beginTime,
            endTime,
          };
          postAction(this.url.queryHomeIndexDone,params).then(res=>{
            if(res.success){
              var data = res.result;
              this.taskList[1].num = data.done;
              resolve(data);
            }
          })
        })
      },
      // 获取业务类别占比
      getHomeIndexTypeNum(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexTypeNum,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption1(data[0].num,data[1].num);
          }
        })
      },
      // 获取业务数量
      getHomeIndexStatsNum(queryType,beginTime,endTime){
        var params = {
          queryType,
          beginTime,
          endTime,
        };
        postAction(this.url.queryHomeIndexStatsNum,params).then(res=>{
          if(res.success){
            var data = res.result;
            this.setOption2(data.xdata,data.ydata);
          }
        })
      },
      // 业务数量查询
      onChange(e){
        this.getHomeIndexStatsNum(e.target.value);
      },
      // 时间范围查询
      onRangeTime(e){
        this.getHomeIndexStatsNum('',e[0],e[1]);
      },
      setOption1(a,b){
        var chartDom1 = document.getElementById('option1');
        var myChart = echarts.init(chartDom1);
        var option = {
          title: {
            text: this.$t('工程报装'),
            left: 'center',
            top: '45%',
            textStyle: {
              fontSize: 20,
              color: '#000',
              align: 'center'
            },
          },
          tooltip: {
            trigger: 'item'
          },
          legend: {
            type: 'scroll',
            orient: 'vertical',
            right: '20%',
            top: 20,
            bottom: 20,
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          series: [
            {
              name: this.$t('工程报装'),
              type: 'pie',
              radius: ['50%', '70%'],
              avoidLabelOverlap: true,
              // hoverAnimation: false, // 禁用鼠标悬浮动画
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 3,
              },
              label: {
                show: true,
                position: 'left',
                formatter: '{b}:{d}%',
                fontSize: 16,
              },
              emphasis: {
                label: {
                  show: true,
                }
              },
              labelLine: {
                show: true
              },
              data: [
                { value: a, name: this.$t('个人'),itemStyle:{normal: {color: '#3BA1FF'},emphasis: {color: '#3BA1FF'}} },
                { value: b, name: this.$t('企业'),itemStyle:{normal: {color: '#69D389'},emphasis: {color: '#69D389'}} },
              ]
            }
          ]
        };
        option && myChart.setOption(option);
      },
      setMytodoList(){
        getAction(this.url.list,{workState:0,pageNo:1,pageSize:5,order:'desc',column: 'createTime'}).then(res=>{
          if(res.success){
            this.dataSource = res.result.records;
          }
        })
      },
      setOption2(xdata,ydata){
        var chartDom = document.getElementById('option2');
        var myChart = echarts.init(chartDom);
        var option = {
          title: {
            text: this.$t('业务数量趋势'),
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '3%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              data: xdata,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          color: ['#3BA1FF'],
          series: [
            {
              name: this.$t('工程报装'),
              type: 'bar',
              barWidth: '30',
              data: ydata
            }
          ]
        };
        option && myChart.setOption(option);
      },
      onMore(){
        this.$router.push('/engineeringInstallation/constructionManagement/toDoList');
      },
    }
  }
</script>

<style scoped lang="less">
  .task{
    /deep/.ant-card-body{
      height: 150px !important;
      padding: 20px !important;
    }
    .task-icon {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      background-color: rgb(0, 162, 255);
      display: flex;
      align-items: center;
      justify-content: center;
    
      .anticon-audit {
        color: #fff;
        font-size: 30px;
      }
    }
    
    .task-content {
      margin-left: 30px;
    
      .task-label {
        font-size: 14px;
        color: #999;
      }
    
      .task-num {
        font-size: 30px;
        font-weight: bold;
        color: #000;
      }
    }
  }
  /deep/.ant-card-body{
    padding: 20px !important;
  }
  /deep/.ant-table-thead > tr > th{
    background-color: #fafafa;
  }
  /deep/.ant-table-thead > tr > th:not(:first-child):before,
  /deep/.ant-table-thead > tr > th:not(:last-child):after{
    background-color: #e8e8e8;
  }
</style>